// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57810383","732":"911cf90a","977":"5df7c158"}[chunkId] + ".chunk.js";
};